var productColums = document.querySelectorAll('.product__columns');
if (productColums.length > 0) {
	var sidebar = new StickySidebar('.product__left-column', {
		topSpacing: 20,
		bottomSpacing: 20,
		containerSelector: '.product__columns',
		innerWrapperSelector: '.product__fixed-content',
		minWidth: 768
	});
}

$(document).ready(function () {
	$('.selector').change(function () {
		id = $(this)
			.children(':selected')
			.data('value');
		$(this)
			.next('input')
			.focus()
			.val(id);
	});
});


// product form
var productForm = {
	init: function () {
		var els = {
			$inputQty: $('[data-product-qty]'),
			$btnAdd: $('[data-product-qty-add]'),
			$btnSubtract: $('[data-product-qty-subtract]')
		};

		els.$btnAdd.on('click', function (e) {
			var qty = parseInt(els.$inputQty.val());
			var plusOne = qty + 1;

			e.preventDefault();

			if (!isNaN(plusOne)) {
				els.$inputQty.val(plusOne)
			}
		});

		els.$btnSubtract.on('click', function (e) {
			var qty = parseInt(els.$inputQty.val());
			var minusOne = qty - 1;

			e.preventDefault();

			if (!isNaN(minusOne) && minusOne > 0) {
				els.$inputQty.val(minusOne)
			}
		});
	}
}

productForm.init();
